import { render, staticRenderFns } from "./PlanningCosts.vue?vue&type=template&id=faa6c3d2&scoped=true"
import script from "./PlanningCosts.vue?vue&type=script&lang=ts"
export * from "./PlanningCosts.vue?vue&type=script&lang=ts"
import style0 from "./PlanningCosts.vue?vue&type=style&index=0&id=faa6c3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa6c3d2",
  null
  
)

export default component.exports